export enum LandingPageSection {
  Home = 'Home',
  Left = 'Left',
  Right = 'Right',
  Up = 'Up',
  Hub = 'Hub',
}
